import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
// import { HaNewquestion } from '../models/HaNewQuestion.model';
import { SurveyInsertQuestionModal } from '../models/SurveyInsertQuestion.model';
import { CreateSurveyModal } from '../models/CreateSurvey.model';
import { ShareSurveyToPatientModal } from '../models/ShareSurveyToPatient.model';

@Injectable()
export class HaSurveyserviceService {

  constructor(private http: HttpClient) { }
  getCaseGroup() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/getSurveyCaseGroups');
  }

  insertSurveyQuestion(insertModal:SurveyInsertQuestionModal) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Survey/insertSurveyQuestion',insertModal);
  }

  getQuestions() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/getQuestions');
  }

  deleteQuestion(questionId,codeType) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/deleteSurveyQuestion?questionId='+questionId+'&codeType='+codeType);
  }

  createSurvey(createModal:CreateSurveyModal) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Survey/createSurvey',createModal);
  }

  getAllHaSurveys(){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/getAllHaSurveys');
  }


  getPatientsToShareSurveyWith(pageNo,text,eaLoginId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/getPatientsToShareSurveyWith?pageNo='+pageNo+'&text='+text+'&eaLoginId='+eaLoginId);
  }

  shareSurveyWithPatient(shareModal:ShareSurveyToPatientModal){

    return this.http.post(globalAdd.Paneladdress + 'api/HA/Survey/shareSurveyWithPatient', shareModal);
  }


  getSharePatientsOfSelectedSurvey(surveyPaperId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/getSharePatientsOfSelectedSurvey?surveyPaperId='+surveyPaperId);
  }

  deleteSurveyPaper(surveyPaperId){
    console.log('works');
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/Survey/deleteSingleSurvey', { surveyPaperId:surveyPaperId});
  }

  deleteSurveyPaperQuestion(surveyPaperId,questionId){
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/Survey/deleteQuestionFromSingleSurvey', { surveyPaperId:surveyPaperId,questionId:questionId});
  }


  getAllHaSurveysQuestions(surveyPaperId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Survey/getAllHaSurveysQuestions?surveyPaperId='+surveyPaperId);
  }

}

